import React, { useState, useEffect } from "react";
import "./SpecialQuizes.css";
import { useNavigate } from "react-router-dom";
import dark from "../../images/sp-banner.png";
import sp from "../../images/sp1.png";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRight } from "@fortawesome/free-solid-svg-icons";
import SpecialSideBar from "../SpecialSideBar/SpecialSideBar";
import ResultPage from "../ResultPage/ResultPage";
import ResultPageLast from "../ResultPageLast/ResultPageLast";
import { useParams } from "react-router-dom";
import { END_URL, IMG_URL } from "../../config";
import buttonloader from "../../images/buttonloader.gif";
import axios from "axios";
import loadimg from "../../images/loader_wish.gif";
import { Helmet } from "react-helmet";
import gg from "../../images/pp-logo.gif";
import arr from "../../images/downarr.svg";

import Subscriptions from "../Subscriptions/Subscriptions";

function SpecialQuizes({ onLoginChange, userdetail }) {
  const { slug } = useParams();

  const [Cluster, setCluster] = useState([]);

  const [isLoading, setIsLoading] = useState(true);

  const token = localStorage.getItem("token");

  const [TestDetail, setTestDetail] = useState([]);

  const [TestInfo, setTestInfo] = useState([]);

  const [Faq, setFaq] = useState([]);

  const [seo, setSeo] = useState({});

  const subS = true;

  const [subscription, setSubscription] = useState(null);

  const [ShowModal, setShowModal] = useState(false);

  const [TestLink, setTestLink] = useState(null);

  const [TestLink1, setTestLink1] = useState(null);

  const [TestLink2, setTestLink2] = useState(null);

  const [TestSubLink, setTestSubLink] = useState(null);

  const [openIndex, setOpenIndex] = useState(0);

  const toggle = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  useEffect(() => {
    const GetArcheTypes = async () => {
      setIsLoading(true);

      try {
        const response = await axios.get(`${END_URL}/get-arche-type/${slug}`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });

        const reponsedata = response?.data;

        const seoDate = reponsedata?.seo_page;

        setSeo(seoDate);

        setCluster(reponsedata?.cluster);

        setTestDetail(reponsedata?.test_detail);

        setTestLink(reponsedata?.test_advertisment_link?.slug);

        setTestLink1(reponsedata?.bannerbuttontext_link?.slug);

        setTestLink2(reponsedata?.archetypebuttontext_link?.slug);

        setTestSubLink(reponsedata?.test_sub_button_link?.slug);

        setTestInfo(reponsedata?.test_info);

        setFaq(reponsedata?.test_faq);

        setIsLoading(false);
      } catch {
        console.log("some error ");
      }
    };

    GetArcheTypes();
  }, [slug]);

  //   useEffect(() => {
  //   const fetchDarkBanner = async () => {
  //     try {
  //       const res = await axios.get(`${END_URL}/dark_banner/${slug}`);
  //       if (res.data.dark_banner?.dark_banner) {
  //         setTestDetail((prev) => ({
  //           ...prev,
  //           dark_banner_image: res.data.dark_banner.dark_banner,
  //         }));
  //       }
  //     } catch (err) {
  //       console.error("Error fetching dark banner:", err);
  //     }
  //   };

  //   fetchDarkBanner();
  // }, [slug]);

  const handleNavigete = (link) => {
    if (link) {
      window.location.href = `/${link}`;
    }
  };

  const LoginShow = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
    onLoginChange(true);
  };

  const LoginShowSub = (subids) => {
    if (subids) {
      try {
        let parsedSubIds;

        if (typeof subids === "string") {
          try {
            parsedSubIds = JSON.parse(subids);
          } catch {
            parsedSubIds = [subids];
          }
        } else if (Array.isArray(subids)) {
          parsedSubIds = subids;
        } else {
          parsedSubIds = [subids];
        }

        localStorage.setItem("pendingSubIds", JSON.stringify(parsedSubIds));
      } catch (error) {
        console.error("Failed to save subids to localStorage:", error);
      }
    }
    window.scrollTo({ top: 0, behavior: "smooth" });
    onLoginChange(true);
  };

  const handleAdClick = async (subJson) => {
    setShowModal(true);

    try {
      const subIds = JSON.parse(subJson);

      if (!Array.isArray(subIds) || subIds.length === 0) return;

      const res = await axios.post(
        `${END_URL}/sub_adver`,
        { ids: subIds },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );

      setSubscription(res.data);

      setShowModal(true);
    } catch (err) {
      console.error("Error loading subscriptions:", err);
    }
  };

  return (
    <>
      <Helmet>
        <title>
          {seo?.meta_title ||
            "PersonalityTest - Discover Your True Archetype | Personality Peek"}
        </title>

        <meta
          name="description"
          content={
            seo?.meta_description ||
            "Take the Personality Test at Personality Peek. Discover your true archetype, unlock insights and start your self-discovery journey."
          }
        />

        <meta
          name="keywords"
          content={
            seo?.meta_keywords ||
            "personality assessment test , personality test"
          }
        />

        {seo?.og_title && <meta property="og:title" content={seo.og_title} />}
        {seo?.og_description && (
          <meta property="og:description" content={seo.og_description} />
        )}
        {seo?.og_image && (
          <meta property="og:image" content={`${IMG_URL}/d0/${seo.og_image}`} />
        )}
        {seo?.og_url && <meta property="og:url" content={seo.og_url} />}
        {seo?.og_type && <meta property="og:type" content={seo.og_type} />}

        {seo?.twitter_title && (
          <meta name="twitter:title" content={seo.twitter_title} />
        )}
        {seo?.twitter_description && (
          <meta name="twitter:description" content={seo.twitter_description} />
        )}
        {seo?.twitter_image && (
          <meta
            name="twitter:image"
            content={`${IMG_URL}/d0/${seo.twitter_image}`}
          />
        )}
        {seo?.twitter_card && (
          <meta name="twitter:card" content={seo.twitter_card} />
        )}

        {seo?.og_url && <link rel="canonical" href={seo.og_url} />}

        {!seo?.og_title && (
          <meta
            property="og:title"
            content="PersonalityTest - Discover Your True Archetype | Personality Peek"
          />
        )}
        {!seo?.og_description && (
          <meta
            property="og:description"
            content="Take the Personality Test at Personality Peek. Discover your true archetype, unlock insights and start your self-discovery journey."
          />
        )}
        {!seo?.og_type && <meta property="og:type" content="website" />}
        {!seo?.twitter_card && (
          <meta name="twitter:card" content="summary_large_image" />
        )}
      </Helmet>

      <div className="special-cont">
        {isLoading ? (
          <div className="loadingDiv">
            <img src={gg} alt="Loading..." />
          </div>
        ) : (
          <>
            <div className="container-fluid special-banner">
              <div className="row">
                <div
                  className="col-md-12 "
                  style={{
                    backgroundImage: TestDetail?.dark_banner_image
                      ? `url(${TestDetail.dark_banner_image})`
                      : `url(${IMG_URL}/d0/${TestDetail?.archetypebg})`,
                    backgroundRepeat: "no-repeat",
                    backgroundPosition: "center center",
                    backgroundSize: "cover",
                  }}
                >
                  <div className="special-banner-text">
                    
                    <h1 dangerouslySetInnerHTML={{__html:TestDetail.arche_title}}/>

                    <h2>{TestInfo?.test_sub_heading}</h2>

                    {TestDetail?.bannerbuttontext && (
                      <a
                        className="button common"
                        // href={`/${TestDetail?.bannerbuttontext_link}`}
                        onClick={
                          token
                            ? TestLink1 != "" && TestLink1 != null
                              ? () => handleNavigete(TestLink1)
                              : () =>
                                  handleAdClick(
                                    TestDetail.bannerbuttontext_link,
                                  )
                            : () =>
                                LoginShowSub(TestDetail.bannerbuttontext_link)
                        }
                      >
                        <span>{TestDetail.bannerbuttontext}</span>

                        <span>
                          <FontAwesomeIcon
                            className="icc"
                            icon={faArrowRight}
                          />{" "}
                        </span>
                        <span></span><span></span><span></span><span></span>
                      </a>
                    )}
                  </div>
                </div>

                {TestInfo?.trust_row_title && (

                  <div className="trust-row">

                    <h2 dangerouslySetInnerHTML={{__html:TestInfo?.trust_row_title}}/>

                  </div>
                )}

              </div>
            </div>

            <div className="container-fluid special-quizes">

              {TestInfo?.test_intro_title && (
                <div className="special-quizes-top-content">
                  <div className="row banner-short-content extr-intro">
                    <h2>{TestInfo?.test_intro_title}</h2>

                    <div
                      dangerouslySetInnerHTML={{
                        __html: TestInfo?.test_intro_des,
                      }}
                    />
                  </div>
                </div>
              )}

              <div className="row">
                {!TestDetail?.up_sell && (
                  <div className="col-12 col-sm-12 col-md-3 col-lg-3 das-res special-res">
                    <SpecialSideBar
                      Cluster={Cluster}
                      sidebartitle={TestDetail?.side_bar_title}
                    />

                    {TestDetail?.advertismentimage && (
                      <a
                        onClick={
                          token
                            ? TestLink != "" && TestLink != null
                              ? () => handleNavigete(TestLink)
                              : () =>
                                  handleAdClick(
                                    TestDetail.test_advertisment_link,
                                  )
                            : () =>
                                LoginShowSub(TestDetail.test_advertisment_link)
                        }
                        className="adver-link"
                      >
                        <div className="special-box2">
                          <div className="special-adds">
                            <img
                              decoding="async"
                              loading="lazy"
                              src={`${IMG_URL}/d0/${TestDetail?.advertismentimage}`}
                              alt="Adverticement Image"
                            />
                          </div>
                        </div>
                      </a>
                    )}
                  </div>
                )}

                <div
                  className={`col-12 col-sm-12 col-md-8 col-lg-8 dark-res special-out ${TestDetail?.up_sell ? "full-width-special" : ""}`}
                >
                  <div className="special-inner">
              
                    <div
                      className="row banner-short-content"
                      dangerouslySetInnerHTML={{
                        __html: TestDetail?.short_description,
                      }}
                    />

                    <div
                      className={`row special-inner-row ${TestDetail?.up_sell ? "full-width" : ""}`}
                    >
                      <div className="col-12 col-sm-12 col-md-12 special-outer-left">
                        {!TestDetail?.up_sell && (
                          <div className="special-box1">
                            {Cluster &&
                              Cluster.length > 0 &&
                              Cluster.map((item, index) => (
                                <div
                                  className={`${
                                    index % 2 == 0
                                      ? "special-box1-inner"
                                      : "special-box1-inner spcial-box1-inner-reverse"
                                  }`}
                                >
                                  <h2>{item.name}</h2>

                                  {item?.dimension &&
                                    item.dimension.length > 0 && (
                                      <div className="row gy-3">
                                        {item.dimension.map(
                                          (dimension, dimIndex) => (
                                            <div
                                              id={`dimension-${dimension.id}`}
                                              style={{
                                                background:
                                                  dimension.bg_color ??
                                                  "revert-layer",
                                              }}
                                              className="col-12 col-sm-12 col-md-12 special-cards"
                                            >
                                              <div className="special-img">
                                                <img
                                                  decoding="async"
                                                  loading="lazy"
                                                  src={`${IMG_URL}/d0/${dimension?.image}`}
                                                  alt={dimension?.imagealt}
                                                />
                                              </div>

                                              <div className="special-texts">
                                                <h4>{dimension.name}</h4>

                                                <h6>
                                                  {" "}
                                                  {dimension.dimension_letter
                                                    .split("")
                                                    .join(" ")}{" "}
                                                  {item.cluster_letter
                                                    .split("")
                                                    .join(" ")}{" "}
                                                   
                                                </h6>

                                                <p
                                                  className="des-paragh-span"
                                                  dangerouslySetInnerHTML={{
                                                    __html:
                                                      dimension.archetype_description,
                                                  }}
                                                />
                                              </div>
                                            </div>
                                          ),
                                        )}
                                      </div>
                                    )}

                                  {TestDetail?.archetypebuttontext && (
                                    <a
                                      className="button common"
                                      // href={`/${TestDetail?.archetypebuttontext_link}`}

                                      onClick={
                                        token
                                          ? TestLink2 != "" && TestLink2 != null
                                            ? () => handleNavigete(TestLink2)
                                            : () =>
                                                handleAdClick(
                                                  TestDetail.archetypebuttontext_link,
                                                )
                                          : () =>
                                              LoginShowSub(
                                                TestDetail.archetypebuttontext_link,
                                              )
                                      }
                                    >
                                      <span>
                                        {TestDetail?.archetypebuttontext}
                                      </span>

                                      <span>
                                        <FontAwesomeIcon
                                          className="icc"
                                          icon={faArrowRight}
                                        />{" "}
                                      </span>
                                    </a>
                                  )}
                                </div>
                              ))}
                          </div>
                        )}

                        {TestDetail?.advertismentimage && (
                          <div
                            className={`special-box2 ${TestDetail?.up_sell ? "full-width" : ""}`}
                          >
                            <div
                              className="special-adds"
                              onClick={
                                token
                                  ? TestLink != "" && TestLink != null
                                    ? () => handleNavigete(TestLink)
                                    : () =>
                                        handleAdClick(
                                          TestDetail.test_advertisment_link,
                                        )
                                  : () =>
                                      LoginShowSub(
                                        TestDetail.test_advertisment_link,
                                      )
                              }
                            >
                              <img
                                decoding="async"
                                loading="lazy"
                                src={`${IMG_URL}/d0/${TestDetail?.advertismentimage}`}
                                alt={TestDetail?.ad_image_alt}
                              />
                            </div>
                          </div>
                        )}
                      </div>
                    </div>

                    {/* <div className="row banner-short-content extr-intro extr-intro-comon extr-intro-bottom1">
                      <h2>{TestInfo?.test_work_title}</h2>

                      <div
                        dangerouslySetInnerHTML={{
                          __html: TestInfo?.test_work_des,
                        }}
                      />
                    </div>

                    <div className="row banner-short-content extr-intro extr-intro-comon extr-intro-bottom">
                      <h2>{TestInfo?.test_clarity_title}</h2>

                      <div
                        dangerouslySetInnerHTML={{
                          __html: TestInfo?.test_clarity_des,
                        }}
                      />
                    </div>

                    <div className="asm-det-faq-div test-faqs">
                      <div className="container">
                        <div className="row">
                          <h2>{TestInfo?.test_faq_title}</h2>

                          <div className="col-12 col-sm-12 col-md-12">
                            <div className="faq-container">
                              {Faq.map((item, index) => (
                                <div
                                  key={index}
                                  className="faq-item"
                                  onClick={() => toggle(index)}
                                >
                                  <div className="faq-title">
                                    <h3>{item.title}</h3>

                                    <span className="arrow-icon">
                                      <img
                                        className={
                                          openIndex === index ? "rotate1" : ""
                                        }
                                        src={arr}
                                        alt=""
                                      />
                                    </span>
                                  </div>
                                  {openIndex === index && (
                                    <div className="faq-content">
                                      <p
                                        dangerouslySetInnerHTML={{
                                          __html: item?.subtitle,
                                        }}
                                      ></p>
                                    </div>
                                  )}
                                  <hr />
                                </div>
                              ))}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div> */}
                  </div>

                  {TestDetail?.advertismentimage && (
                    <div className="row special-add-bottom">
                      <div className="special-box2">
                        <div
                          className="special-adds"
                          onClick={
                            token
                              ? TestLink != "" && TestLink != null
                                ? () => handleNavigete(TestLink)
                                : () =>
                                    handleAdClick(
                                      TestDetail.test_advertisment_link,
                                    )
                              : () =>
                                  LoginShowSub(
                                    TestDetail.test_advertisment_link,
                                  )
                          }
                        >
                          <img
                            decoding="async"
                            loading="lazy"
                            src={`${IMG_URL}/d0/${TestDetail?.advertismentimage}`}
                            alt="Adverticement Image"
                          />
                        </div>
                      </div>
                    </div>
                  )}

                  <>
                    {isLoading ? (
                      <div className="skeleton3 skldivs"></div>
                    ) : (
                      <ResultPageLast
                        token={token}
                        demension={TestDetail}
                        onLoginChange={onLoginChange}
                        payment={TestDetail?.payment}
                        type="special_quiz"
                        TestLink={TestSubLink}
                      />
                    )}
                  </>
                </div>
              </div>

              <div className="row special-quiz-new">

                {TestInfo?.test_work_title &&(

                    <div className="row banner-short-content extr-intro extr-intro-comon extr-intro-bottom1">
                      <h2>{TestInfo?.test_work_title}</h2>

                      <div
                        dangerouslySetInnerHTML={{
                          __html: TestInfo?.test_work_des,
                        }}
                      />
                    </div>
                )}

              {TestInfo?.test_clarity_title && (

                  <div className="row banner-short-content extr-intro extr-intro-comon extr-intro-bottom">
                    <h2>{TestInfo?.test_clarity_title}</h2>

                    <div
                      dangerouslySetInnerHTML={{
                        __html: TestInfo?.test_clarity_des,
                      }}
                    />
                  </div>
              )}

                {Faq?.length > 0 && (

                  <div className="asm-det-faq-div test-faqs">
          
                      <div className="row">
                        <h2>{TestInfo?.test_faq_title}</h2>

                        <div className="col-12 col-sm-12 col-md-12">
                          <div className="faq-container">
                            {Faq.map((item, index) => (
                              <div
                                key={index}
                                className="faq-item"
                                onClick={() => toggle(index)}
                              >
                                <div className="faq-title">
                                  <h3>{item.title}</h3>

                                  <span className="arrow-icon">
                                    <img
                                      className={
                                        openIndex === index ? "rotate1" : ""
                                      }
                                      src={arr}
                                      alt=""
                                    />
                                  </span>
                                </div>
                                {openIndex === index && (
                                  <div className="faq-content">
                                    <p
                                      dangerouslySetInnerHTML={{
                                        __html: item?.subtitle,
                                      }}
                                    ></p>
                                  </div>
                                )}
                                <hr />
                              </div>
                            ))}
                          </div>
                        </div>
                      </div>
              
                  </div>
                  
                )}

              </div>


            </div>
          </>
        )}
      </div>

      {ShowModal && (
        <div
          className={`newdashpop-overlay subs-cognit-modal1 modal_subcript ${
            subscription?.data?.length == 1 ? "single-subscription" : ""
          }`}
        >
          <div className="newdashpop-inner">
            <div className="newdashpop-container">
              <button
                className="newdashpop-close"
                onClick={() => setShowModal(false)}
              >
                &times;
              </button>

              <div className="conent-pop">
                <Subscriptions
                  subs={subS}
                  userdetail={userdetail}
                  Subcription={subscription}
                  onLoginChange={onLoginChange}
                />
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default SpecialQuizes;
